import { createAsyncAction, createAction } from "typesafe-actions";

import { MODULE, SUB_MODULE } from "app/pages/sales-intelligence/modules/enrichment/constants/constants";
import type {
    EnrichmentPreview,
    EnrichmentConfigItem,
} from "app/pages/sales-intelligence/modules/enrichment/store/type";
import type {
    ContactsParsingErrors,
    ParsedContactsResult,
    ParseDomainsResult,
    CompanyParsingErrors,
} from "app/pages/sales-intelligence/sub-modules/management/components/types";
import type { FetchError } from "app/pages/sales-intelligence/types";

export const getSelectedColumnsConfigAsync = createAsyncAction(
    `@@si/${MODULE}/${SUB_MODULE}/GET_SELECTED_COLUMNS_CONFIG_START`,
    `@@si/${MODULE}/${SUB_MODULE}/GET_SELECTED_COLUMNS_CONFIG_SUCCESS`,
    `@@si/${MODULE}/${SUB_MODULE}/GET_SELECTED_COLUMNS_CONFIG_FAILURE`,
)<void, readonly EnrichmentConfigItem[], FetchError>();

export const getContactsSelectedColumnsConfigAsync = createAsyncAction(
    `@@si/${MODULE}/${SUB_MODULE}/GET_SELECTED_COLUMNS_CONTACTS_CONFIG_START`,
    `@@si/${MODULE}/${SUB_MODULE}/GET_SELECTED_COLUMNS_CONTACTS_CONFIG_SUCCESS`,
    `@@si/${MODULE}/${SUB_MODULE}/GET_SELECTED_COLUMNS_CONTACTS_CONFIG_FAILURE`,
)<void, EnrichmentConfigItem[], FetchError>();

export const getPreviewAsync = createAsyncAction(
    `@@si/${MODULE}/${SUB_MODULE}/GET_PREVIEW_START`,
    `@@si/${MODULE}/${SUB_MODULE}/GET_PREVIEW_SUCCESS`,
    `@@si/${MODULE}/${SUB_MODULE}/GET_PREVIEW_FAILURE`,
)<void, EnrichmentPreview, FetchError>();

export const getEnrichedCsvAsync = createAsyncAction(
    `@@si/${MODULE}/${SUB_MODULE}/GET_ENRICHED_CSV_START`,
    `@@si/${MODULE}/${SUB_MODULE}/GET_ENRICHED_CSV_SUCCESS`,
    `@@si/${MODULE}/${SUB_MODULE}/GET_ENRICHED_CSV_FAILURE`,
)<void, string, FetchError>();

export const parseEnrichmentCsvAsync = createAsyncAction(
    `@@si/${MODULE}/${SUB_MODULE}/PARSE_CSV_START`,
    `@@si/${MODULE}/${SUB_MODULE}/PARSE_CSV_SUCCESS`,
    `@@si/${MODULE}/${SUB_MODULE}/PARSE_CSV_FAILURE`,
)<void, ParseDomainsResult, CompanyParsingErrors>();

export const parseContactsEnrichmentCsvAsync = createAsyncAction(
    `@@si/${MODULE}/${SUB_MODULE}/PARSE_CONTACTS_CSV_START`,
    `@@si/${MODULE}/${SUB_MODULE}/PARSE_CONTACTS_CSV_SUCCESS`,
    `@@si/${MODULE}/${SUB_MODULE}/PARSE_CONTACTS_CSV_FAILURE`,
)<void, ParsedContactsResult, ContactsParsingErrors>();

export const postEnrichmentCsvAsync = createAsyncAction(
    `@@si/${MODULE}/${SUB_MODULE}/POST_CSV_START`,
    `@@si/${MODULE}/${SUB_MODULE}/POST_CSV_SUCCESS`,
    `@@si/${MODULE}/${SUB_MODULE}/POST_CSV_FAILURE`,
)<void, void, FetchError>();

export const postContactsEnrichmentCsvAsync = createAsyncAction(
    `@@si/${MODULE}/${SUB_MODULE}/POST_CONTACTS_CSV_START`,
    `@@si/${MODULE}/${SUB_MODULE}/POST_CONTACTS_CSV_SUCCESS`,
    `@@si/${MODULE}/${SUB_MODULE}/POST_CONTACTS_CSV_FAILURE`,
)<void, void, FetchError>();

export const enrichmentFinishedAction = createAction(`@@si/${MODULE}/${SUB_MODULE}/ENRICHMENT_FINISHED`)<void>();

export const createStaticListAsync = createAsyncAction(
    `@@si/${MODULE}/${SUB_MODULE}/CREATE_STATIC_LIST_START`,
    `@@si/${MODULE}/${SUB_MODULE}/CREATE_STATIC_LIST_SUCCESS`,
    `@@si/${MODULE}/${SUB_MODULE}/CREATE_STATIC_LIST_FAILURE`,
)<void, void, FetchError>();

export const clearEnrichmentParsing = createAction(`@@si/${MODULE}/${SUB_MODULE}/CLEAR_PARSING`)<void>();
